import { stylePropsView } from "@tamagui/helpers";
import { createPropMapper } from "./createPropMapper.js";
import { mergeProps } from "./mergeProps.js";
function extendStaticConfig(config, parent) {
  if (!(parent && "staticConfig" in parent)) {
    return parseStaticConfig(config);
  }
  const parentStaticConfig = parent.staticConfig;
  const variants = {
    ...parentStaticConfig.variants
  };
  if (config.variants) {
    for (const key in config.variants) {
      if (variants[key]) {
        variants[key] = {
          ...variants[key],
          ...config.variants[key]
        };
      } else {
        variants[key] = config.variants[key];
      }
    }
  }
  const parentNames = [...parentStaticConfig.parentNames || []];
  if (parentStaticConfig.componentName) {
    parentNames.push(parentStaticConfig.componentName);
  }
  const deoptProps = config.deoptProps || /* @__PURE__ */ new Set();
  return parseStaticConfig({
    ...parentStaticConfig,
    ...config,
    parentStaticConfig,
    deoptProps,
    variants,
    parentNames,
    validStyles: config.validStyles ? {
      ...parentStaticConfig.validStyles,
      ...config.validStyles
    } : parentStaticConfig.validStyles || stylePropsView,
    defaultProps: mergeProps(
      {
        ...parentStaticConfig.defaultProps,
        ...parentStaticConfig.defaultVariants
      },
      {
        ...config.defaultProps,
        ...config.defaultVariants
      }
    )[0]
  });
}
const parseStaticConfig = (config) => {
  const parsed = {
    defaultProps: {},
    ...config,
    parsed: true
  };
  return {
    ...parsed,
    propMapper: createPropMapper(parsed)
  };
};
export {
  extendStaticConfig,
  parseStaticConfig
};
//# sourceMappingURL=extendStaticConfig.js.map
